module.exports = __webpack_public_path__ + "img/home_white_icon.d3ab3729.svg";